module.exports = __webpack_public_path__ + "static/sword_wraith-8fa06750a739e8594e90cbdb9e8315ee.png";